import {createLessonUrl} from "./lessonPageFactory";
import IMyDashboardResponse, {
  IMyDashboardResponseLastPlayed,
  IMyDashboardResponseRecentLesson
} from "../client/models/myDashboard/IMyDashboardResponse";
import {
  IDashboardPageLastPlayed,
  IDashboardPageRecentlyPlayedLesson
} from "../modules/dashboard/store/IDashboardPageStore";
import {IDashboardLoadPayload} from "../modules/dashboard/store/dashboardPageSlice";

export function createDashboardPageViewModel(myDashboardResponse: IMyDashboardResponse): IDashboardLoadPayload {
  const {lastPlayed} = myDashboardResponse;
  return {
    ...myDashboardResponse,
    lastPlayed: createDashboardLastPlayedLesson(lastPlayed),
    // Static stub data for testing purposes
    recentlyPlayed: {
      ...myDashboardResponse.recentlyPlayed ?? {},
      lessons: (myDashboardResponse.recentlyPlayed.lessons ?? []).map(createDashboardRecentlyPlayedLesson),
    }

  };
}

const createDashboardRecentlyPlayedLesson = (recentlyPlayed: IMyDashboardResponseRecentLesson): IDashboardPageRecentlyPlayedLesson => {

  const {name, thumbnailUrl, lessonId, segmentId, type, percentComplete, difficultyCategory} = recentlyPlayed;
  const hashUrl = createLessonUrl(lessonId, segmentId, undefined, undefined, `/dashboard`);

  return {
    lessonId,
    segmentId,
    name,
    thumbnailUrl,
    hashUrl,
    type,
    percentComplete,
    difficultyCategory,
  };

}

const createDashboardLastPlayedLesson = (lastPlayed: Optional<IMyDashboardResponseLastPlayed>): Optional<IDashboardPageLastPlayed> => {
  if (!lastPlayed){
    // don't have lastPlayed, return undefined
    return undefined;
  }

  const {name, thumbnailUrl, lessonId, segmentId} = lastPlayed;
  const hashUrl = createLessonUrl(lessonId, segmentId, undefined, undefined, `/dashboard`);

  return {
    lessonId,
    segmentId,
    name,
    thumbnailUrl,
    hashUrl,
  };

}

export function getBootcampUrl(difficultyLevel: string) {
  switch (difficultyLevel) {
    case "rookie":
      return `/bootCamp/35`;
    case "intermediate":
      return `/bootCamp/36`;
    case "advanced":
      return `/bootCamp/37`;
  }
  return '';
}
